module.exports = "https://cdn.realtymogul.com/static/media/merlinIcons.5c8cc52c.svg";